export enum MessageCheckerEndpoint {
  Base = '/edifact',
  IFTSTA = '/iftsta',
  SC4 = '/sc4',
  SC3 = '/sc3',
  Validate = '/validate',
}
